import { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import './index.scss'

import AppHeader from '../../components/Header'
import AppFooter from '../../components/Footer'

import PRODUCTCONFIG from '../../configs/product'

class ProductDetail extends Component {

  state = {
    activeIndex: 0
  }

  componentDidMount () {
    document.getElementById('root').scrollTop = 0
  }

  handleChangeImage (direction) {
    let { type, id } = this.props.location.state
    let { info } = PRODUCTCONFIG
    let images = info[type].content[id].images
    let { activeIndex } = this.state
    let index = direction === '1' ? activeIndex - 1 : activeIndex + 1
    if (index < 0) index = 0
    if (index >= images.length - 1) index = images.length - 1
    if (index === activeIndex) return
    this.setState({ activeIndex: index})
  }

  handleViewImage (index) {
    this.setState({ activeIndex: index})
  }

  render () {
    let { lang, location } = this.props
    let { type, id } = location.state
    let { activeIndex } = this.state
    let { title, info } = PRODUCTCONFIG
    let product = info[type].content[id]
    return (
      <div className='app-page page-product-detail'>
        <AppHeader />
        <div className='page-container'>
          <div className='product-header box background-image' style={{ backgroundImage: `url(${title.background})` }}>
            <div className='box-content flex-align-justify'>{title[lang]}</div>
          </div>
          <div className='flex-justify'>
            <div className='product-container max-width'>
              <div className='product-info flex'>
                <div className='info-image'>
                  <div className='box'>
                    {product.images[activeIndex].type === 'image' && <div className='box-content background-image' style={{ backgroundImage: `url(${product.images[activeIndex].src})` }}></div>}
                    {product.images[activeIndex].type === 'video' && <div className='info-video box-content flex-align'>
                      <video src={product.images[activeIndex].src} controls loop></video>  
                    </div>}
                  </div>
                  <div className='image-list flex'>
                    <div className='list-btn flex-align-justify' onClick={this.handleChangeImage.bind(this, '1')}>
                      <span className='iconfont icon-arrow-lf'></span>
                    </div>
                    <div className='list-wrapper flex-one'>
                      <div className='list-container' style={{ transform: `translateX(-${parseInt(activeIndex / 4) * 100}%)` }}>
                        {
                          product.images.map((item, index) => {
                            return (
                              <Fragment key={index}>
                                {item.type === 'image' && <div
                                  className={`list-item box background-image ${index === activeIndex ? 'active' : ''}`}
                                  style={{ backgroundImage: `url(${item.src})` }}
                                  onMouseOver={this.handleViewImage.bind(this, index)}
                                  onClick={this.handleViewImage.bind(this, index)}
                                ></div>}
                                {item.type === 'video' && <div
                                  className={`list-item box background-image ${index === activeIndex ? 'active' : ''}`}
                                  onMouseOver={this.handleViewImage.bind(this, index)}
                                  onClick={this.handleViewImage.bind(this, index)}
                                >
                                  <video className='box-content' src={item.src}></video>
                                </div>}
                              </Fragment>
                            )
                          })
                        }
                      </div>
                    </div>
                    <div className='list-btn flex-align-justify' onClick={this.handleChangeImage.bind(this, '2')}>
                      <span className='iconfont icon-arrow-rf'></span>
                    </div>
                  </div>
                </div>
                <div className='info-detail flex-one'>
                  <div className='detail-title'>{product.name[lang]}</div>
                  {
                    product.introduction.map((item, index) => {
                      return (
                        <div className='detail-introduction' key={index}>{item[lang]}</div>
                      )
                    })
                  }
                </div>
              </div>
              {product.detail && product.detail.length > 0 && <div className='product-detail'>
                {
                  product.detail.map((item, index) => {
                    return (
                      <Fragment key={index}>
                        {item.type === 'image' && <img className='detail-item' alt='' src={item.src}></img>}
                      </Fragment>
                    )
                  })
                }
              </div>}
            </div>
          </div>
        </div>
        <AppFooter />
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    lang: state.app.lang
  }
}

export default withRouter(connect(mapStateToProps)(ProductDetail))
